import { useState, useEffect } from 'react';
import axios from 'axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import dayjs from 'dayjs';

const API = 'https://golf-reservation-backend.onrender.com';

export default function ExecutivePage({ onLogout }) {
  const user = JSON.parse(localStorage.getItem('golf_user'));
  const [tab, setTab] = useState('request');
  const [allMemberships, setAllMemberships] = useState([]); // eslint-disable-line no-unused-vars
  const [memberships, setMemberships] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [membershipRules, setMembershipRules] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [usageInfo, setUsageInfo] = useState(null);
  const [usageWarning, setUsageWarning] = useState('');
  const [form, setForm] = useState({
    membership_id: '',
    desired_date: '',
    desired_time: '',
    companions: '',
    note: '',
    is_proxy: false,
    actual_user_name: '',
    check_time: false,
  });

  useEffect(() => { fetchData(); }, []); // eslint-disable-line

const fetchData = async () => {
  try {
    const [mem, allMem, res, rules] = await Promise.all([
      axios.get(`${API}/memberships?user_id=${user.id}`),
      axios.get(`${API}/memberships`),
      axios.get(`${API}/reservations`),
      axios.get(`${API}/membership-rules`),
    ]);
    const myReservations = res.data.filter(r => r.requester_id === user.id);
    setMemberships(mem.data);
    setAllMemberships(allMem.data);
    setReservations(myReservations);
    setMembershipRules(rules.data);
    return {
      memberships: mem.data,
      allMemberships: allMem.data,
      reservations: myReservations,
      rules: rules.data,
    };
  } catch (e) { console.log(e); }
};

const checkUsageWithData = async (membership_id, desired_date) => {
  if (!membership_id || !desired_date) {
    setUsageInfo(null);
    setUsageWarning('');
    return;
  }

  try {
    const date = new Date(desired_date);
    const year = date.getFullYear();
    const month = date.getMonth();
    const isWeekend = date.getDay() === 0 || date.getDay() === 6;
    const dayType = isWeekend ? '주말' : '주중';

    // 전체 예약 데이터 직접 조회
    const [resResponse, memResponse, rulesResponse] = await Promise.all([
      axios.get(`${API}/reservations`),
      axios.get(`${API}/memberships`),
      axios.get(`${API}/membership-rules`),
    ]);

    const allRes = resResponse.data;
    const allMem = memResponse.data;
    const allRules = rulesResponse.data;

    // 같은 골프장 회원권 ID 목록
    const selectedMembership = allMem.find(m => m.id === membership_id);
    if (!selectedMembership) { console.log('❌ selectedMembership not found, membership_id:', membership_id); return; }

    console.log('✅ selectedMembership:', selectedMembership.club_name, selectedMembership.member_type);
    console.log('📋 allMem:', allMem.map(m => `${m.id}=${m.club_name}(${m.member_type})`));

    const sameClubIds = allMem
      .filter(m => m.club_name === selectedMembership.club_name)
      .map(m => m.id);

    console.log('🏌️ sameClubIds:', sameClubIds);
    console.log('📅 찾는 연월:', year, month);
    console.log('📊 전체 예약 수:', allRes.length);
    allRes.forEach(r => {
      console.log(`  예약: membership_id=${r.membership_id}, status=${r.status}, confirmed=${r.confirmed_date}, desired=${r.desired_date}, inClub=${sameClubIds.includes(r.membership_id)}`);
    });

    // 같은 골프장 전체 회원의 이번 달 예약 (정회원+지정회원 합산)
    const monthRes = allRes.filter(r => {
      if (!sameClubIds.includes(r.membership_id)) return false;
      if (r.status === 'rejected') return false;
      const d = new Date(r.confirmed_date || r.desired_date);
      return d.getFullYear() === year && d.getMonth() === month;
    });

    console.log('🎯 monthRes:', monthRes.length, '건');

    const weekdayCount = monthRes.filter(r => {
      const d = new Date(r.confirmed_date || r.desired_date);
      return d.getDay() !== 0 && d.getDay() !== 6;
    }).length;

    const weekendCount = monthRes.filter(r => {
      const d = new Date(r.confirmed_date || r.desired_date);
      return d.getDay() === 0 || d.getDay() === 6;
    }).length;

    const count = { weekday: weekdayCount, weekend: weekendCount };
    setUsageInfo(count);

    const rule = allRules.find(r => r.membership_id === membership_id);
    if (!rule) { setUsageWarning(''); return; }

    const limit = isWeekend ? rule.weekend_limit : rule.weekday_limit;
    const used = isWeekend ? count.weekend : count.weekday;

    if (used >= limit) {
      setUsageWarning(`⚠️ 이번 달 ${selectedMembership.club_name} ${dayType} 예약 한도 ${limit}회를 초과했어요. (현재 ${used}회 사용 중)`);
    } else if (used >= limit - 1) {
      setUsageWarning(`주의: 이번 달 ${selectedMembership.club_name} ${dayType} 예약 잔여 횟수가 ${limit - used}회 남았어요.`);
    } else {
      setUsageWarning('');
    }
  } catch (e) {
    console.log('사용 현황 조회 실패:', e);
  }
};

const handleMembershipChange = (membership_id) => {
  setForm(prev => ({ ...prev, membership_id }));
  checkUsageWithData(membership_id, form.desired_date);
};

const handleDateChange = (desired_date) => {
  setForm(prev => ({ ...prev, desired_date }));
  checkUsageWithData(form.membership_id, desired_date);
};

  const handleSubmit = async () => {
    if (!form.membership_id || !form.desired_date) {
      alert('코스와 희망 날짜는 필수예요!'); return;
    }
    if (!form.desired_time && !form.check_time) {
      alert('희망 티타임을 입력하거나 "가능 시간 확인 요청"을 체크해주세요!'); return;
    }
    if (form.is_proxy && !form.actual_user_name) {
      alert('실제 사용자 이름을 입력해주세요!'); return;
    }
    if (usageWarning.startsWith('⚠️')) {
      const proceed = window.confirm(usageWarning + '\n\n그래도 예약을 신청하시겠어요?');
    if (!proceed) return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/reservations`, { ...form, requester_id: user.id });
      setSuccess('예약 요청이 완료됐어요! 담당 비서에게 알림이 전송됐습니다.');
      setShowForm(false);
      setUsageInfo(null);
      setUsageWarning('');
      setForm({
        membership_id: '', desired_date: '', desired_time: '',
        companions: '', note: '', is_proxy: false,
        actual_user_name: '', check_time: false,
      });
      fetchData();
      setTimeout(() => setSuccess(''), 4000);
    } catch (e) {
      alert(e.response?.data?.error || '요청 실패. 다시 시도해주세요.');
    }
    setLoading(false);
  };

  const handleCancel = async (id) => {
    if (!window.confirm('예약을 취소하시겠어요? 취소 후 복구할 수 없습니다.')) return;
    try {
      await axios.delete(`${API}/reservations/${id}/executive`);
      fetchData();
    } catch (e) {
      alert(e.response?.data?.error || '취소 실패. 다시 시도해주세요.');
    }
  };

  const statusLabel = (status) => {
    if (status === 'pending') return { text: '검토 중', color: '#f59e0b', bg: '#fef3c7' };
    if (status === 'confirmed') return { text: '예약 확정', color: '#059669', bg: '#d1fae5' };
    if (status === 'rejected') return { text: '예약 불가', color: '#dc2626', bg: '#fee2e2' };
  };

  const getReservationsForDate = (date) => {
    const dateStr = date.toLocaleDateString('sv-SE');
    return reservations.filter(r => (r.confirmed_date || r.desired_date) === dateStr);
  };

  const tileContent = ({ date, view }) => {
    if (view !== 'month') return null;
    const list = getReservationsForDate(date);
    if (list.length === 0) return null;
    return (
      <div style={{ display: 'flex', justifyContent: 'center', gap: '2px', marginTop: '2px' }}>
        {list.map((r, i) => {
          const s = statusLabel(r.status);
          return <div key={i} style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: s.color }} />;
        })}
      </div>
    );
  };

  const selectedDateReservations = selectedDate ? getReservationsForDate(selectedDate) : [];
  const selectedRule = membershipRules.find(r => r.membership_id === form.membership_id);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <p style={styles.headerSub}>안녕하세요</p>
          <p style={styles.headerName}>{user?.name}님 ⛳</p>
        </div>
        <button style={styles.logoutBtn} onClick={onLogout}>로그아웃</button>
      </div>

      <div style={styles.content}>
        {success && <div style={styles.successBox}>{success}</div>}

        <div style={styles.tabRow}>
          {[
            { key: 'request', label: '예약 요청' },
            { key: 'list', label: '예약 내역' },
            { key: 'calendar', label: '달력' },
          ].map(t => (
            <button
              key={t.key}
              style={{ ...styles.tab, ...(tab === t.key ? styles.tabActive : {}) }}
              onClick={() => { setTab(t.key); setShowForm(false); }}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* 예약 요청 탭 */}
        {tab === 'request' && (
          <div>
            {!showForm ? (
              <button style={styles.mainButton} onClick={() => setShowForm(true)}>
                + 예약 요청하기
              </button>
            ) : (
              <div style={styles.card}>
                <h2 style={styles.cardTitle}>새 예약 요청</h2>

                <label style={styles.label}>골프장 · 회원권 *</label>
                <select style={styles.input} value={form.membership_id}
                  onChange={e => handleMembershipChange(e.target.value)}
                >
                  <option value="">선택해주세요</option>
                  {memberships.map(m => (
                    <option key={m.id} value={m.id}>{m.club_name} · {m.member_type}</option>
                  ))}
                </select>

                {selectedRule && (
                  <div style={styles.ruleBox}>
                    📋 예약 한도: 주중 {selectedRule.weekday_limit}회 · 주말 {selectedRule.weekend_limit}회
                    {selectedRule.delegation_weekday_limit > 0 && ` · 위임 주중 ${selectedRule.delegation_weekday_limit}회`}
                    {selectedRule.delegation_weekend_limit > 0 && ` · 위임 주말 ${selectedRule.delegation_weekend_limit}회`}
                    {selectedRule.note && ` · ${selectedRule.note}`}
                  </div>
                )}

                <label style={styles.label}>희망 날짜 *</label>
                <input style={styles.input} type="date"
                  min={dayjs().add(1, 'day').format('YYYY-MM-DD')}
                  value={form.desired_date}
                  onChange={e => handleDateChange(e.target.value)}
                />

                {usageInfo && form.membership_id && form.desired_date && (
                  <div style={styles.usageBox}>
                    📊 이번 달 사용 현황: 주중 {usageInfo.weekday}회 · 주말 {usageInfo.weekend}회
                  </div>
                )}

                {usageWarning && (
                  <div style={usageWarning.startsWith('⚠️') ? styles.warningBox : styles.cautionBox}>
                    {usageWarning}
                  </div>
                )}

                <label style={styles.label}>희망 티타임</label>
                <input
                  style={{ ...styles.input, backgroundColor: form.check_time ? '#f3f4f6' : 'white' }}
                  type="time"
                  value={form.desired_time}
                  disabled={form.check_time}
                  onChange={e => setForm({ ...form, desired_time: e.target.value })}
                />
                <div style={styles.checkRow}>
                  <label style={styles.checkLabel}>
                    <input
                      type="checkbox"
                      checked={form.check_time}
                      onChange={e => setForm({ ...form, check_time: e.target.checked, desired_time: '' })}
                      style={{ marginRight: '8px' }}
                    />
                    해당일 예약 가능 시간 확인 요청 (비서가 시간 결정)
                  </label>
                </div>

                <label style={styles.label}>동반자</label>
                <input style={styles.input} type="text"
                  placeholder="예: 김철수 상무, 이영희 전무"
                  value={form.companions}
                  onChange={e => setForm({ ...form, companions: e.target.value })}
                />

                <div style={styles.checkRow}>
                  <label style={styles.checkLabel}>
                    <input
                      type="checkbox"
                      checked={form.is_proxy}
                      onChange={e => setForm({ ...form, is_proxy: e.target.checked, actual_user_name: '' })}
                      style={{ marginRight: '8px' }}
                    />
                    지인 대리 예약 (본인 외 다른 분이 사용)
                  </label>
                </div>

                {form.is_proxy && (
                  <div>
                    <label style={styles.label}>실제 사용자 이름 *</label>
                    <input style={styles.input} type="text"
                      placeholder="실제 골프 치시는 분 성함"
                      value={form.actual_user_name}
                      onChange={e => setForm({ ...form, actual_user_name: e.target.value })}
                    />
                  </div>
                )}

                <label style={styles.label}>메모</label>
                <textarea
                  style={{ ...styles.input, height: '80px', resize: 'none' }}
                  placeholder="특이사항이 있으면 입력해주세요"
                  value={form.note}
                  onChange={e => setForm({ ...form, note: e.target.value })}
                />

                <div style={styles.buttonRow}>
                  <button style={styles.cancelBtn} onClick={() => {
                    setShowForm(false);
                    setUsageInfo(null);
                    setUsageWarning('');
                  }}>취소</button>
                  <button style={styles.submitBtn} onClick={handleSubmit} disabled={loading}>
                    {loading ? '요청 중...' : '요청 보내기'}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* 예약 내역 탭 */}
        {tab === 'list' && (
          <div>
            <h2 style={styles.sectionTitle}>내 예약 내역 ({reservations.length}건)</h2>
            {reservations.length === 0 ? (
              <div style={styles.emptyBox}>아직 예약 내역이 없어요</div>
            ) : (
              reservations.map(r => {
                const s = statusLabel(r.status);
                return (
                  <div key={r.id} style={styles.reservationCard}>
                    <div style={styles.reservationHeader}>
                      <div>
                        <p style={styles.clubName}>{r.membership?.club_name} · {r.membership?.member_type}</p>
                        {r.is_proxy && <p style={styles.proxyInfo}>대리예약 · {r.actual_user_name}</p>}
                        {r.check_time && <p style={styles.proxyInfo}>가능 시간 확인 요청</p>}
                      </div>
                      <span style={{ ...styles.statusBadge, color: s.color, backgroundColor: s.bg }}>{s.text}</span>
                    </div>
                    <p style={styles.infoText}>
                      희망일: {dayjs(r.desired_date).format('YYYY년 MM월 DD일')}
                      {r.desired_time && ` · ${r.desired_time}`}
                    </p>
                    {r.status === 'confirmed' && r.confirmed_date && (
                      <p style={styles.confirmedText}>
                        확정일: {dayjs(r.confirmed_date).format('YYYY년 MM월 DD일')}
                        {r.confirmed_time && ` · ${r.confirmed_time}`}
                      </p>
                    )}
                    {r.companions && <p style={styles.infoText}>동반자: {r.companions}</p>}
                    {r.note && <p style={styles.infoText}>메모: {r.note}</p>}
                    {r.secretary_direct && <span style={styles.directBadge}>비서 직접 예약</span>}
                    <p style={styles.dateText}>요청일: {r.created_at?.slice(0, 10)}</p>
                    {(r.status === 'pending' || r.status === 'confirmed') && (
                      <button style={styles.cancelBtn2} onClick={() => handleCancel(r.id)}>
                        예약 취소
                      </button>
                    )}
                  </div>
                );
              })
            )}
          </div>
        )}

        {/* 달력 탭 */}
        {tab === 'calendar' && (
          <div>
            <div style={styles.card}>
              <style>{`
                .react-calendar { width: 100%; border: none; font-family: inherit; }
                .react-calendar__tile { padding: 10px 6px; font-size: 13px; }
                .react-calendar__tile--active { background: #2d6a4f !important; color: white !important; border-radius: 6px; }
                .react-calendar__tile--now { background: #d1fae5; border-radius: 6px; }
                .react-calendar__navigation button { font-size: 14px; font-weight: 600; }
              `}</style>
              <Calendar onChange={setSelectedDate} value={selectedDate} tileContent={tileContent} locale="ko-KR" />
            </div>
            {selectedDate ? (
              <div>
                <h2 style={styles.sectionTitle}>
                  {selectedDate.toLocaleDateString('ko-KR', { month: 'long', day: 'numeric', weekday: 'short' })} ({selectedDateReservations.length}건)
                </h2>
                {selectedDateReservations.length === 0 ? (
                  <div style={styles.emptyBox}>이 날짜에 예약이 없어요</div>
                ) : (
                  selectedDateReservations.map(r => {
                    const s = statusLabel(r.status);
                    return (
                      <div key={r.id} style={styles.reservationCard}>
                        <div style={styles.reservationHeader}>
                          <div>
                            <p style={styles.clubName}>{r.membership?.club_name} · {r.membership?.member_type}</p>
                            {r.is_proxy && <p style={styles.proxyInfo}>대리예약 · {r.actual_user_name}</p>}
                          </div>
                          <span style={{ ...styles.statusBadge, color: s.color, backgroundColor: s.bg }}>{s.text}</span>
                        </div>
                        <p style={styles.infoText}>희망일: {r.desired_date}{r.desired_time && ` · ${r.desired_time}`}</p>
                        {r.confirmed_date && <p style={styles.confirmedText}>확정일: {r.confirmed_date}{r.confirmed_time && ` · ${r.confirmed_time}`}</p>}
                        {r.companions && <p style={styles.infoText}>동반자: {r.companions}</p>}
                      </div>
                    );
                  })
                )}
              </div>
            ) : (
              <div style={styles.emptyBox}>달력에서 날짜를 선택하면 예약 내역이 표시돼요</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', backgroundColor: '#f0f4f0' },
  header: {
    backgroundColor: '#2d6a4f', padding: '20px 24px',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  },
  headerSub: { color: '#a8d5b5', fontSize: '12px' },
  headerName: { color: 'white', fontSize: '18px', fontWeight: '600' },
  logoutBtn: {
    backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.4)',
    color: 'white', padding: '6px 14px', borderRadius: '6px', fontSize: '13px',
  },
  content: { padding: '20px 16px', maxWidth: '600px', margin: '0 auto' },
  successBox: {
    backgroundColor: '#d1fae5', color: '#065f46',
    padding: '14px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px',
  },
  tabRow: { display: 'flex', gap: '8px', marginBottom: '16px' },
  tab: {
    flex: 1, padding: '10px', backgroundColor: 'white',
    border: '1px solid #ddd', borderRadius: '8px',
    fontSize: '13px', fontWeight: '500', color: '#666',
  },
  tabActive: { backgroundColor: '#2d6a4f', color: 'white', border: '1px solid #2d6a4f' },
  mainButton: {
    width: '100%', padding: '16px', backgroundColor: '#2d6a4f',
    color: 'white', border: 'none', borderRadius: '10px',
    fontSize: '16px', fontWeight: '600', marginBottom: '20px',
  },
  card: {
    backgroundColor: 'white', borderRadius: '12px',
    padding: '20px', marginBottom: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },
  cardTitle: { fontSize: '17px', fontWeight: '600', marginBottom: '16px' },
  label: { fontSize: '13px', fontWeight: '500', color: '#555', display: 'block', marginBottom: '6px', marginTop: '12px' },
  input: {
    width: '100%', padding: '11px 13px',
    border: '1px solid #ddd', borderRadius: '8px',
    fontSize: '14px', outline: 'none', backgroundColor: 'white',
  },
  ruleBox: {
    backgroundColor: '#f0fdf4', color: '#166534',
    padding: '8px 12px', borderRadius: '6px',
    fontSize: '12px', marginTop: '6px',
  },
  usageBox: {
    backgroundColor: '#eff6ff', color: '#1d4ed8',
    padding: '8px 12px', borderRadius: '6px',
    fontSize: '12px', marginTop: '6px', fontWeight: '500',
  },
  warningBox: {
    backgroundColor: '#fef2f2', color: '#dc2626',
    padding: '10px 12px', borderRadius: '6px',
    fontSize: '13px', fontWeight: '500', marginTop: '6px',
    border: '1px solid #fecaca',
  },
  cautionBox: {
    backgroundColor: '#fffbeb', color: '#d97706',
    padding: '10px 12px', borderRadius: '6px',
    fontSize: '13px', fontWeight: '500', marginTop: '6px',
    border: '1px solid #fde68a',
  },
  checkRow: { marginTop: '12px', marginBottom: '4px' },
  checkLabel: { fontSize: '14px', color: '#444', cursor: 'pointer', display: 'flex', alignItems: 'center' },
  buttonRow: { display: 'flex', gap: '10px', marginTop: '20px' },
  cancelBtn: {
    flex: 1, padding: '12px', backgroundColor: 'white',
    border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px',
  },
  submitBtn: {
    flex: 2, padding: '12px', backgroundColor: '#2d6a4f',
    color: 'white', border: 'none', borderRadius: '8px',
    fontSize: '14px', fontWeight: '600',
  },
  sectionTitle: { fontSize: '16px', fontWeight: '600', marginBottom: '12px' },
  emptyBox: {
    backgroundColor: 'white', borderRadius: '10px',
    padding: '32px', textAlign: 'center', color: '#aaa', fontSize: '14px',
  },
  reservationCard: {
    backgroundColor: 'white', borderRadius: '10px',
    padding: '16px', marginBottom: '10px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  },
  reservationHeader: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'flex-start', marginBottom: '8px',
  },
  clubName: { fontSize: '15px', fontWeight: '600', marginBottom: '2px' },
  proxyInfo: { fontSize: '12px', color: '#7c3aed', marginTop: '2px' },
  statusBadge: { fontSize: '12px', fontWeight: '600', padding: '3px 10px', borderRadius: '20px' },
  infoText: { fontSize: '13px', color: '#555', marginBottom: '4px' },
  confirmedText: { fontSize: '13px', color: '#059669', fontWeight: '500', marginBottom: '4px' },
  directBadge: {
    fontSize: '11px', color: '#0369a1', backgroundColor: '#e0f2fe',
    padding: '2px 8px', borderRadius: '10px', display: 'inline-block', marginTop: '4px',
  },
  dateText: { fontSize: '11px', color: '#bbb', marginTop: '8px' },
  cancelBtn2: {
    marginTop: '10px', width: '100%', padding: '8px',
    backgroundColor: 'white', border: '1px solid #fca5a5',
    color: '#dc2626', borderRadius: '8px', fontSize: '13px',
  },
};